/* src/components/features/departures/CountdownBar/CountdownBar.tsx */
import type { ComponentProps } from 'preact';
import styles from './CountdownBar.module.css';

export interface CountdownBarProps extends Omit<
  ComponentProps<'div'>,
  'children' | 'className'
> {
  secondsRemaining: number;
  totalSeconds?: number;
}

export function CountdownBar({
  secondsRemaining,
  totalSeconds = 60,
  ...props
}: CountdownBarProps) {
  const progress = Math.min(Math.max(secondsRemaining / totalSeconds, 0), 1);

  const isAtStart = secondsRemaining >= totalSeconds;
  const transitionStyle = isAtStart ? 'none' : 'transform 1s linear';

  return (
    <div className={styles.track} aria-hidden="true" {...props}>
      <div
        className={styles.fill}
        style={{
          transform: `scaleX(${progress})`,
          transition: transitionStyle,
          transformOrigin: 'left center',
        }}
      />
    </div>
  );
}
